import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExternalmenuComponent } from '../../../shared/externalmenu/externalmenu.component';
// import { PermissionService } from './permission.service';
import { ToastService } from '../../../core/services/toast.service';
import { log } from 'echarts/types/src/util/log.js';
import { ApiService } from '../../../core/services/api.service';
import { HttpClient } from '@angular/common/http';
import { PermissionService } from './permission.service';
import { SidebarService } from '../../../core/services/sidebar.service';

declare var bootstrap: any;
@Component({
  selector: 'app-rolepermissions',
  imports: [ExternalmenuComponent, CommonModule, FormsModule],
  templateUrl: './rolepermissions.html',
  styleUrl: './rolepermissions.scss'
})
export class Rolepermissions {
  public userInfo: any;
  greeting: string = '';
  currentDateString: string = '';
  selected = 'W';
  public loading = false;
  Roles: any;
  widgetData: any[] = [];
  filteredWidgets: any[] = [];
  selectedRole: any = null;
  dropdownOpen = false;
  logedInUser: any
  userId: any;
  groupcode: any;
  roleId: any;
  title: string = '';
  isaddwidgets = false;
  categories: any[] = [];
  Array = Array;
  private toast = inject(ToastService);
  baseUrl: any;


  constructor(
    private api: PermissionService,
    private eRef: ElementRef, public apiService: ApiService,
    private http: HttpClient, private sidebarService: SidebarService) {
    this.setHeaderData();
  }
  setHeaderData() {
    const HeaderData = {
      title: 'Role Based Widgets',
    };
    this.apiService.SetHeaderData({ obj: HeaderData });

  }
  isSidebarCollapsed = false;

  ngOnInit(): void {

    this.sidebarService.isCollapsed$.subscribe((collapsed: any) => {
      this.isSidebarCollapsed = collapsed;
    });

    // this.getCategories('');
    this.getWidgets();
    this.getroles();
    this.getCategories();

    const userStr = localStorage.getItem('userInfo');


    this.logedInUser = userStr ? JSON.parse(userStr) : null;
    const userId = localStorage.getItem('fcmToken')
    this.userId = userId ? JSON.parse(userId) : null;

    this.groupcode = (this.logedInUser?.group == 'CAV1' ? 'CAV' : this.logedInUser?.group)
    this.roleId = this.logedInUser?.user_Info?.roleid;
    console.log('sdjdfhdfj', this.roleId);

  }

  select(option: string) {
    this.selected = option;
    console.log(this.selected)

    if (option = 'R') {
      this.getroles();
    }
  }

  getWidgets() {
    this.filteredWidgets = [];
    this.widgetData = [];
    this.loading = true;
    const userStr = localStorage.getItem('userInfo');
    const user = userStr ? JSON.parse(userStr) : null;
    const group = user && user.group === 'CAV1' ? 'CAV' : user?.group;
    console.log(group);
    this.groupcode = group;


    this.api.getmethod2('widgets', '').subscribe({
      next: (res: any) => {

        const group = user?.group === 'CAV1' ? 'CAV' : user?.group;


        this.widgetData = res
          .filter((widget: any) => widget?.Widget_Group_Code === group)
          .map((widget: any) => ({
            ...widget,
            Widget_size: widget.Widget_size === 0 ? 0.5 : parseFloat(widget.Widget_size)
          }));

        this.filteredWidgets = [...this.widgetData];
        this.loading = false;
        this.updateCategorySelection();
      },
      error: (err: any) => {
        console.error("Error fetching widgets:", err);
        this.loading = false;
      }
    });
  }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    this.dropdownOpen = false;
    this.roleDropdownOpen = false;
    // this.CategoryDropdownOpen = false
  }

  roles: any;
  selectedGroup: any;
  roleDropdownOpen: boolean = false;
  // CategoryDropdownOpen:boolean =  false;
  isaddwidget: any = true;
  toggleRoleDropdown(event: MouseEvent) {
    this.isaddwidgets = true
    event.stopPropagation();
    setTimeout(() => {
      this.roleDropdownOpen = !this.roleDropdownOpen;
    }, 0);
  }

  OnRoleSelect(role: string) {
    this.selectedRole = role;
    this.roleDropdownOpen = false;
    console.log('Selected Role:', role);
    this.checkAndFetchRoleWidgets()
  }

  getSelectedRoleName() {
    const selectedRole = this.selectedRole;
    return selectedRole ? selectedRole.Role_Name : 'Select Role';
  }



  getSelectedGrpName() {
    const group = this.logedInUser && this.logedInUser.group === 'CAV1' ? 'CAV' : this.logedInUser?.group;
    this.selectedGroup = group;
    const selectedRole = this.selectedGroup;
    return selectedRole ? selectedRole : 'Select Category';
  }


  checkAndFetchRoleWidgets() {
    if (this.selectedRole && this.selectedGroup) {
      const roleUniqId = this.selectedRole.Role_Uniqid;
      const groupCode = String(this.selectedGroup);

      this.getRoleWidgets(roleUniqId);
      console.log(roleUniqId, groupCode);
    }
  }


  roleWidgets: any = {};
  allGroupWidgets: any[] = [];
  RoleBaseWidgets: any;

  currentEditingRole: any;

  getRoleWidgets(role: any) {
    console.log(role);
    this.isaddwidget = false
    this.loading = true;
    this.selectedRole = role;

    const group = this.logedInUser && this.logedInUser.group === 'CAV1' ? 'CAV' : this.logedInUser?.group;

    const body = {
      roleUniqid: role.Role_Uniqid,
      groupcode: group
    };

    this.api.postmethod('widgets/byRole', body).subscribe({
      next: (res: any) => {
        try {
          if (res?.data) {
            this.RoleBaseWidgets = res.data;
            console.log("RoleWidgets", this.RoleBaseWidgets);

            const roleBaseIds = this.RoleBaseWidgets.map((widget: any) => widget.Widget_id);

            this.filteredWidgets = (this.filteredWidgets ?? []).map((widget: any) => {
              const isAssigned = roleBaseIds.includes(widget.Widget_id);
              return {
                ...widget,
                Widget_status: isAssigned ? 'Y' : 'N',
                selected: isAssigned // for checkbox binding
              };
            });
            this.buildCategoriesWithWidgets();

            console.log("FinalWidgets", this.filteredWidgets);
          } else {
            console.warn('Empty response for widgets');
          }

          const modal = new bootstrap.Modal(document.getElementById('roleWidgetModal'));
          modal.show();
        } catch (err: any) {
          console.error('Error processing widgets response:', err);
        } finally {
          this.loading = false;
        }
      },
      error: (err: any) => {
        console.error("Server error:", err);
        this.loading = false;
      }
    });

    this.currentEditingRole = role;
  }


  isInRoleWidgets(widgetId: number): boolean {
    return this.RoleBaseWidgets?.some((rw: any) => rw.Widget_id === widgetId);
  }

  onStatusToggle(role: any, event: Event): void {
    const input = event.target as HTMLInputElement;
    role.Role_Status = input.checked ? 'Y' : 'N';
  }

  saveRoleWidgets() {
    if (!this.currentEditingRole) {
      console.error("No role selected for saving widgets");
      this.toast.show('No role selected for saving widgets', 'warning', 'Warning');
      return;
    }

    const selectedWidgetIds = this.categoriesWithWidgets
      .flatMap((cat: { widgets: any; }) => cat.widgets)   // take all widgets
      .filter((widget: { selected: any; }) => widget.selected) // only checked ones
      .map((widget: { Widget_id: any; }) => widget.Widget_id);  // get ids

    const roleId = this.currentEditingRole.Role_Uniqid;
    const groupCode = this.logedInUser && this.logedInUser.group === 'CAV1'
      ? 'CAV'
      : this.logedInUser?.group;

    const body = {
      axelWidgets: selectedWidgetIds.toString(),   // <-- send as array
      updatedUserId: this.roleId,
      dashBoardSeq: this.selectedRole.ROLE_DASHBOARD_POSITION
    };

    console.log('djjbody', this.currentEditingRole);


    this.loading = true;

    this.api.putmethod(`roles/${roleId}/${groupCode}/axelglobal-widgets`, body).subscribe({
      next: (res: any) => {
        console.log("API Response:", res);
        this.loading = false;
        this.getRoleWidgets(this.currentEditingRole);
        this.toast.show('Widget permissions updated', 'success', 'Succuess');
      },
      error: (err: any) => {
        console.error("API Error:", err);
        this.loading = false;
        this.toast.show('Failed to update permissions', 'warning', 'Error');
      }
    });
  }

  getroles() {

    this.loading = true;

    const groupCode = this.logedInUser && this.logedInUser.group === 'CAV1' ? 'CAV' : this.logedInUser?.group;
    console.log(this.groupcode);


    return new Promise((resolve, reject) => {
      this.api.getmethod2(`roles/groupcode/${this.groupcode}`, '').subscribe({
        next: (res: any) => {
          this.loading = false;
          resolve(this.roles = res);
        },
        error: () => {
          this.loading = false;
          reject('Failed to fetch Data');
        }
      });
    });

  }

  enforceSequenceMin(event: any) {
    const value = parseInt(event.target.value, 10);
    if (value < 1 || isNaN(value)) {
      this.modalWidget.Widget_sequence = 1;
    }
  }
  showModal: any;
  selectedWidget: any;
  isEditMode: any;
  // userId: any;
  availableWidgetNames: any;

  openWidgetModal(widget: any = null) {
    this.showModal = true;
    this.selectedWidget = widget;
    if (widget) {
      this.isEditMode = true;
      this.modalWidget = {
        Widget_Group_ID: widget.Widget_Group_ID ?? 0,
        Widget_Group_Code: widget.Widget_Group_Code ?? '',
        Widget_CategoryID: widget.Widget_CategoryID?.trim() ?? '',
        Widget_Header: widget.Widget_Header?.trim() ?? '',
        Widget_Body: widget.Widget_Body?.trim() ?? '',
        Widget_Description: widget.Widget_Description?.trim() ?? '',
        Widget_name: widget.Widget_name ?? '',
        Widget_status: widget.Widget_status ?? 'Y',
        Widget_size: parseFloat(widget.Widget_size) ?? 1,
        Widget_chartEnable: widget.Widget_chartEnable ?? false,
        Widget_sequence: widget.Widget_sequence ?? 1,
        Widget_updatedId: this.userId?.user_aou_id ?? 1
      };
    } else {
      this.isEditMode = false;
      this.modalWidget = {
        Widget_Group_ID: 4,
        Widget_Group_Code: '',
        Widget_CategoryID: '',
        Widget_Header: '',
        Widget_Body: '',
        Widget_Description: '',
        Widget_name: '',
        Widget_status: 'Y',
        Widget_size: 1,
        Widget_chartEnable: false,
        Widget_sequence: 1,
        Widget_createdId: this.userId?.user_aou_id ?? 1
      };
    }
  }

  modalWidget: any = {};


  closeModal() {
    this.showModal = false;
    this.modalWidget = {};
    this.isEditMode = false;
  }
  normalWidgets: any
  saveWidget() {
    const payload = { ...this.modalWidget };

    if (this.isEditMode && this.selectedWidget.Widget_id) {
      this.api.putmethod(`widgets/${this.selectedWidget.Widget_id}`, payload).subscribe((res: any) => {
        this.filteredWidgets = [];
        this.toast.show('Widget permissions updated', 'success', 'Succuess');
        this.closeModal();
      });
      console.log("Editing")
    } else {
      this.api.postmethod('widgets', payload).subscribe((res: any) => {
        this.filteredWidgets = [];
        this.toast.show('Widget permissions updated', 'success', 'Succuess');
        this.closeModal();
      });
      console.log("Editing")
    }
  }
  // filteredWidgets:any

  allWidgets: any
  selectAll: any
  widgets: any


  getCategories() {

    this.api.getmethod2('categories', '').subscribe({
      next: (res: any) => {

        // console.log(res, "rami ramki jrasa");
        this.categories = res;
        this.updateCategorySelection();

      }
    });
  }
  filterWidgetsByCategory(twlId: number) {
    this.filteredWidgets = this.widgets
      .filter((w: any) => Number(w.Widget_CategoryID.trim()) === twlId)
      .map((w: any) => {
        const category = this.categories.find((c: any) => c.TWL_ID === twlId);
        return {
          ...w,
          selected: false,
          TWL_NAME: category ? category.TWL_NAME : ''  // 👈 attach category name
        };
      });

    console.log('Filtered Widgets:', this.filteredWidgets);
  }

  updateCategorySelection() {
    this.categories = this.categories.map((cat: any) => {
      const hasWidgets = this.widgets.some(
        (w: any) => Number(w.Widget_CategoryID.trim()) === cat.TWL_ID
      );
      return { ...cat, selected: hasWidgets };  // 👈 auto-check if widgets exist
    });
  }

  getwidget() {
    this.isaddwidgets = true
    this.isaddwidget = true

  }

  categoriesWithWidgets: any;

  buildCategoriesWithWidgets() {
    if (!this.categories || !this.filteredWidgets) return;

    this.categoriesWithWidgets = this.categories.map((cat: any) => {
      // Widgets belonging to this category
      const widgetsForCat = this.filteredWidgets
        .filter((w: any) => Number(w.Widget_CategoryID?.trim()) === cat.TWL_ID)
        .map((w: any) => ({
          ...w,
          selected: w.Widget_status === 'Y', // checked only if status = Y
          categoryName: cat.TWL_NAME
        }));

      // Category state calculation
      const allChecked = widgetsForCat.length > 0 && widgetsForCat.every((w: any) => w.selected);
      const someChecked = widgetsForCat.some((w: any) => w.selected);

      return {
        ...cat,
        widgets: widgetsForCat,
        selected: allChecked,                         // ✅ only if ALL widgets = Y
        indeterminate: someChecked && !allChecked     // ✅ partial check = dash
      };
    });

    console.log("Categories with Widgets:", this.categoriesWithWidgets);
  }

  updateCategoryState(cat: any) {
    const allChecked = cat.widgets.length > 0 && cat.widgets.every((w: any) => w.selected);
    const someChecked = cat.widgets.some((w: any) => w.selected);

    cat.selected = allChecked;
    cat.indeterminate = someChecked && !allChecked;
  }

  toggleCategory(cat: any) {
    cat.indeterminate = false;
    cat.widgets.forEach((w: any) => {
      w.selected = cat.selected;
      w.Widget_status = cat.selected ? 'Y' : 'N'; // keep consistency
    });
  }

}
